const state = {
  elementDeptId:[],
  eimsUser: {},
  eimsUserInfoBase: {},
  majorDepartId:'',
  userId:'',
  name:''
}

const mutations = {
  getBasicInfo(state, obj){
    state.elementDeptId=obj.eimsUser.elementDeptId;
    state.eimsUserInfoBase = obj.eimsUserInfoBase;
    state.eimsUser = obj.eimsUser;
    state.majorDepartId = obj.eimsUser.majorDepartId;
    state.userId = obj.eimsUser.userId;
    state.name = obj.eimsUser.name;
  },

  clearEimsUser(state){
    state.eimsUser = {};
    state.eimsUserInfoBase = {};
    state.majorDepartId = '';
    state.userId = '';
    state.elementDeptId = [];
  },


}

const actions = {
  getBasicInfo:({commit, state}, obj) => commit("getBasicInfo", obj),
  clearEimsUser:({commit, state}, obj) => commit("clearEimsUser", obj),
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/basicInfoModule.js